import { NgTemplateOutlet } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ITablaColumna } from '@core/interfaces/tabla.interface';
import { UiButton } from '@shared/components/ui';
import { UiProgressSpinner } from '@shared/components/ui';

@Component({
  selector: 'app-tabla',
  imports: [NgTemplateOutlet, UiButton, UiProgressSpinner],
  templateUrl: './tabla.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tabla.css',
})
export class Tabla {
  titulo = input<string | undefined>(undefined);

  columnas = input.required<ITablaColumna[]>();
  accionesTemplate = input<any>();

  datos = input.required<any[]>();
  loading = input<boolean>(false);
  textoVacio = input<string>('Sin datos');
  ocultarAcciones = input<boolean>(false);

  editar = output<any>();
  eliminar = output<any>();

  getNestedValue(obj: any, key: string): any {
    return key.split('.').reduce((current, prop) => current?.[prop], obj);
  }

  getImageForColumn(row: any, col: ITablaColumna): string | null {
    const key = col.imageKey ?? col.key;
    const value = this.getNestedValue(row, key);
    if (!value) return null;
    return String(value);
  }

  onEditar(data: any) {
    this.editar.emit(data);
  }
  onEliminar(data: any) {
    this.eliminar.emit(data);
  }

  transformValue(value: any, pipe: any, format?: string) {
    if (format) {
      return pipe.transform(value, format);
    }
    return pipe.transform(value);
  }
}
